import React, { FC } from 'react';
// 定义页面来源
// 首页
const Home: FC = React.lazy(() => import('../pages/Home'));
//方案库_控制类场景
const PowerAutomation: FC = React.lazy(() => import('../pages/PowerAutomation'));//配电自动化
const PowerDistributionSynthesis: FC = React.lazy(() => import('../pages/PowerDistributionSynthesis'));//配电综合
const NetWorkHapoopProtect: FC = React.lazy(() => import('../pages/NetWorkHapoopProtect'));//配网分布式差动保护
const TypePerceive: FC = React.lazy(() => import('../pages/TypePerceive'));//态势感知
const Photovoltaic: FC = React.lazy(() => import('../pages/Photovoltaic'));//分布式光伏
const PowerSlicingGateway: FC = React.lazy(() => import('../pages/PowerSlicingGateway'));//5G智能电力切片网关

//方案库_采集类场景
const PowerCollection: FC = React.lazy(() => import('../pages/PowerCollection'));//用电信息采集
const ChargeSystem: FC = React.lazy(() => import('../pages/ChargeSystem'));//车联网充电站/桩系统
const MonitorSystem: FC = React.lazy(() => import('../pages/MonitorSystem'));//分布式电源监控系统
const VirtualMeasurement: FC = React.lazy(() => import('../pages/VirtualMeasurement'));//虚拟量测平台

//方案库_移动应用类/交互类场景
const RobotInspection: FC = React.lazy(() => import('../pages/RobotInspection'));//机器人/无人机巡检
const MECVRMR: FC = React.lazy(() => import('../pages/MECVRMR'));//VRMR
const VideoInspection: FC = React.lazy(() => import('../pages/VideoInspection'));//5G高清视频监控
const Tunnel: FC = React.lazy(() => import('../pages/Tunnel'));//隧道
const Satellite: FC = React.lazy(() => import('../pages/Satellite'));//卫星

//知识库_组网部署
const SANSA: FC = React.lazy(() => import('../pages/SANSA'));//5G SA和NSA部署模式
const MEC: FC = React.lazy(() => import('../pages/MEC'));//5G MEC
const LAN: FC = React.lazy(() => import('../pages/LAN'));//5G LAN技术
const TSN: FC = React.lazy(() => import('../pages/TSN'));//5G TSN技术
const NetworkSlice: FC = React.lazy(() => import('../pages/NetworkSlice'));//5G 网络切片

//知识库_应用场景
const eMBB: FC = React.lazy(() => import('../pages/EMBB'));//embb
const uRLLC: FC = React.lazy(() => import('../pages/URLLC'));//urllc
const mMTC: FC = React.lazy(() => import('../pages/MMTC'));//mmtc

//知识库_工业互联网融合
const MecPark: FC = React.lazy(() => import('../pages/MecPark'));//mec园区
const Factory: FC = React.lazy(() => import('../pages/Factory'));//工厂改造
/* const CompareNsaNa: FC = React.lazy(() => import('../pages/CompareNsaNa'));

const DimensionalNetwork: FC = React.lazy(() => import('../pages/DimensionalNetwork'));
const HybridNetwork: FC = React.lazy(() => import('../pages/HybridNetwork'));
const UltraDenseNetwork: FC = React.lazy(() => import('../pages/UltraDenseNetwork'));

const DeploymentRouteOne: FC = React.lazy(() => import('../pages/DeploymentRouteOne'));
const DeploymentRouteTwo: FC = React.lazy(() => import('../pages/DeploymentRouteTwo'));

const EvolutionStrategyOne: FC = React.lazy(() => import('../pages/EvolutionStrategyOne'));
const EvolutionStrategyTwo: FC = React.lazy(() => import('../pages/EvolutionStrategyTwo'));
const EvolutionStrategyThree: FC = React.lazy(() => import('../pages/EvolutionStrategyThree')); */



const SimulationPlatform: FC = React.lazy(() => import('../pages/SimulationPlatform'));//仿真平台
const TrainingCenter: FC = React.lazy(() => import('../pages/TrainingCenter'));//5g培训中心
const buptict: FC = React.lazy(() => import('../pages/buptict'));//5g培训中心

// const Register: FC = React.lazy(() => import('../pages/Register'));
// const UserInfo: FC = React.lazy(() => import('../pages/UserInfo'));
const NotFound: FC = React.lazy(() => import('../components/common/NotFound'));//404

interface routeProps {
    path: string,
    exact: boolean,
    component: FC,
    auth: boolean,
}
//定义界面路由 path是路由地址
const routes:routeProps[] = [
    { path: '/', exact: true, component:Home, auth: false },
    { path: '/powerAutomation', exact: true, component: PowerAutomation, auth: false },
    { path: '/PowerDistributionSynthesis', exact: true, component: PowerDistributionSynthesis, auth: false },
    { path: '/netWorkHapoopProtect', exact: true, component: NetWorkHapoopProtect, auth: false },
    { path: '/typePerceive', exact: true, component: TypePerceive, auth: false },
    { path: '/Photovoltaic', exact: true, component: Photovoltaic, auth: false },
    { path: '/PowerSlicingGateway', exact: true, component: PowerSlicingGateway, auth: false },

    { path: '/powerCollection', exact: true, component: PowerCollection, auth: false },
    { path: '/chargeSystem', exact: true, component: ChargeSystem, auth: false },
    { path: '/monitorSystem', exact: true, component: MonitorSystem, auth: false },
    { path: '/VirtualMeasurement', exact: true, component: VirtualMeasurement, auth: false },


    { path: '/robotInspection', exact: true, component: RobotInspection, auth: false },
    { path: '/MECVRMR', exact: true, component: MECVRMR, auth: false },
    { path: '/videoInspection', exact: true, component: VideoInspection, auth: false },
    { path: '/Tunnel', exact: true, component: Tunnel, auth: false },
    { path: '/Satellite', exact: true, component: Satellite, auth: false },

    { path: '/saNsa', exact: true, component: SANSA, auth: false },
    { path: '/mec', exact: true, component: MEC, auth: false },
    { path: '/lan', exact: true, component: LAN, auth: false },
    { path: '/tsn', exact: true, component: TSN, auth: false },
    { path: '/networkSlice', exact: true, component: NetworkSlice, auth: false },

    { path: '/eMBB', exact: true, component: eMBB, auth: false },
    { path: '/uRLLC', exact: true, component: uRLLC, auth: false },
    { path: '/mMTC', exact: true, component: mMTC, auth: false },

    { path: '/mecPark', exact: true, component: MecPark, auth: false },
    { path: '/factory', exact: true, component: Factory, auth: false },

    { path: '/simulationPlatform', exact: true, component: SimulationPlatform, auth: false },
    { path: '/trainingCenter', exact: true, component: TrainingCenter, auth: false },
    { path: '/buptict', exact: true, component: buptict, auth: false },
    /*{ path: '/nsa', exact: true, component: NSA, auth: false },
    { path: '/sa', exact: true, component: SA, auth: false },
    { path: '/compare-nsa-sa', exact: true, component: CompareNsaNa, auth: false },
    { path: '/dimensionalNetwork', exact: true, component: DimensionalNetwork, auth: false },
    { path: '/hybridNetwork', exact: true, component: HybridNetwork, auth: false },
    { path: '/ultraDenseNetwork', exact: true, component: UltraDenseNetwork, auth: false },

    { path: '/simulationPlatform', exact: true, component: SimulationPlatform, auth: false },
    // { path: '/trainingCenter', exact: true, component: TrainingCenter, auth: false },

    { path: '/deploymentRouteOne', exact: true, component: DeploymentRouteOne, auth: false },
    { path: '/deploymentRouteTwo', exact: true, component: DeploymentRouteTwo, auth: false },

    { path: '/evolutionStrategyOne', exact: true, component: EvolutionStrategyOne, auth: false },
    { path: '/evolutionStrategyTwo', exact: true, component: EvolutionStrategyTwo, auth: false },
    { path: '/evolutionStrategyThree', exact: true, component: EvolutionStrategyThree, auth: false },*/

    // { path: '/register', exact: true, component: Register, auth: false },
    // { path: '/userInfo', exact: true, component: UserInfo, auth: true },
    { path: '*', exact: true, component: NotFound, auth: false },
]

export default routes;